export default {
    root: ({state}) => ({
        class: [
            // Shape
            "rounded-lg min-w-4xl",
            "shadow-lg",
            "border-0",
            // "mx-3",

            // Size
            "h--full max-h-[90vh]",
            "w-full max-w-7xl",
            "m-0",

            // Color
            "dark:border",
            "dark:border-stone-700",

            // Transitions
            "transform",
            "scale-100",

            // Maximized State
            {
                "transition-none": state.maximized,
                "transform-none": state.maximized,
                "!w-screen": state.maximized,
                "!h-screen": state.maximized,
                "!max-h-full !max-w-full": state.maximized,
                "!top-0": state.maximized,
                "!left-0": state.maximized,
            },
        ],
    }),
    header: {
        class: [
            // Flexbox and Alignment
            "flex items--center justify-between",
            "shrink-0",

            // Spacing
            "px-4 pt-3",

            // Shape
            "border-t-0",
            "rounded-tl-lg",
            "rounded-tr-lg",

            // Colors
            "bg-stone-50 dark:bg-stone-800",
            "text-stone-700 dark:text-stone-50/80",
        ],
    },
    title: {
        class: ["font-bold text-lg"],
    },
    headerActions: {
        class: ["flex items-center"],
    },
    pcclosebutton: {
        root: {
            class: ["ring-0 pl-2 pt-1"],
        },
    },
    content: ({state, instance}) => ({
        class: [
            // Spacing
            "px-4",
            "pb-4",
            "pt-0",

            // Shape
            {
                grow: state.maximized,
                "rounded-bl-lg": !instance.$slots.footer,
                "rounded-br-lg": !instance.$slots.footer,
            },

            // Colors
            "bg-stone-50 dark:bg-stone-800",
            "text-stone-700 dark:text-stone-50/80",

            // Misc
            "overflow-y-auto h-full",
        ],
    }),
    footer: {
        class: [
            // Flexbox and Alignment
            "flex items-center justify-end",
            "shrink-0",
            "text-right",
            "gap-2",

            // Spacing
            "px-4",
            "pb-4",

            // Shape
            "border-t-0",
            "rounded-b-lg",

            // Colors
            "bg-stone-50 dark:bg-stone-800",
            "text-stone-700 dark:text-stone-50/80",
        ],
    },
    mask: ({props, attrs}) => ({
        class: [
            // Transitions
            "transition-all",
            "duration-300",
            {"p-5": !props.position == "full"},

            // Background and Effects
            {
                "has-[.mask-active]:bg-transparent bg-black/60": props.modal,
                "has-[.mask-active]:backdrop-blur-none backdrop-blur-sm": props.modal && attrs.backdrop === "blur",
            },
        ],
    }),
    transition: ({props}) => {
        return props.position === "top"
            ? {
                  enterFromClass: "opacity-0 scale-75 translate-x-0 -translate-y-full translate-z-0 mask-active",
                  enterActiveClass: "transition-all duration-200 ease-out",
                  leaveActiveClass: "transition-all duration-200 ease-out",
                  leaveToClass: "opacity-0 scale-75 translate-x-0 -translate-y-full translate-z-0 mask-active",
              }
            : props.position === "bottom"
              ? {
                    enterFromClass: "opacity-0 scale-75 translate-y-full mask-active",
                    enterActiveClass: "transition-all duration-200 ease-out",
                    leaveActiveClass: "transition-all duration-200 ease-out",
                    leaveToClass: "opacity-0 scale-75 translate-x-0 translate-y-full translate-z-0 mask-active",
                }
              : props.position === "left" || props.position === "topleft" || props.position === "bottomleft"
                ? {
                      enterFromClass: "opacity-0 scale-75 -translate-x-full translate-y-0 translate-z-0 mask-active",
                      enterActiveClass: "transition-all duration-200 ease-out",
                      leaveActiveClass: "transition-all duration-200 ease-out",
                      leaveToClass: "opacity-0 scale-75  -translate-x-full translate-y-0 translate-z-0 mask-active",
                  }
                : props.position === "right" || props.position === "topright" || props.position === "bottomright"
                  ? {
                        enterFromClass: "opacity-0 scale-75 translate-x-full translate-y-0 translate-z-0 mask-active",
                        enterActiveClass: "transition-all duration-200 ease-out",
                        leaveActiveClass: "transition-all duration-200 ease-out",
                        leaveToClass: "opacity-0 scale-75 translate-x-full translate-y-0 translate-z-0 mask-active",
                    }
                  : {
                        enterFromClass: "opacity-0 scale-75 mask-active",
                        enterActiveClass: "transition-all duration-200 ease-out",
                        leaveActiveClass: "transition-all duration-200 ease-out",
                        leaveToClass: "opacity-0 scale-75 mask-active",
                    };
    },
};
